const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

/** Decimal units to match what file managers and hosts show. */
export function formatBytes(n: number | null | undefined, digits = 1): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return '—';
  if (n < 1000) return `${Math.round(n)} B`;
  let v = n;
  let i = 0;
  while (v >= 1000 && i < UNITS.length - 1) {
    v /= 1000;
    i++;
  }
  return `${v.toFixed(v >= 100 ? 0 : digits)} ${UNITS[i]}`;
}

export function formatRate(bytesPerSecond: number | null): string {
  if (bytesPerSecond === null || !Number.isFinite(bytesPerSecond)) return '—';
  return `${formatBytes(bytesPerSecond)}/s`;
}

export function formatDuration(totalSeconds: number | null | undefined): string {
  if (totalSeconds === null || totalSeconds === undefined || !Number.isFinite(totalSeconds))
    return '—';
  const s = Math.max(0, Math.round(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const mm = h > 0 ? String(m).padStart(2, '0') : String(m);
  return `${h > 0 ? `${h}:` : ''}${mm}:${String(sec).padStart(2, '0')}`;
}

export function formatPercent(fraction: number | null): string {
  if (fraction === null || !Number.isFinite(fraction)) return '—';
  const p = Math.max(0, Math.min(1, fraction)) * 100;
  return p >= 99.95 && p < 100 ? '99.9%' : `${p < 10 ? p.toFixed(1) : Math.floor(p)}%`;
}

/** ETA only after enough observations exist. TYPE-034 */
export function formatEta(
  remainingBytes: number,
  bytesPerSecond: number | null,
  samples: number,
): string {
  if (bytesPerSecond === null || bytesPerSecond <= 0 || samples < 4) return 'Estimating…';
  const secs = remainingBytes / bytesPerSecond;
  if (secs > 60 * 60 * 48) return 'More than 2 days';
  if (secs < 1) return 'Under a second';
  return `${formatDuration(secs)} left`;
}
